var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#1a181c",
      "margin-top": "auto",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "container pt-40 color-fff"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "block mb-40"
  }, [_c('div', {
    staticClass: "b-title pl-20 fs-16 bold mb-20"
  }, [_vm._v(_vm._s(_vm.$t("pagebottom.sponsor")))]), _vm._v(" "), _vm._l((_vm.list1), function(v, i) {
    return _c('a', {
      key: i,
      staticClass: "pl-20 fs-14 mb-20 link",
      attrs: {
        "href": v.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(v.name) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "block mb-40"
  }, [_c('div', {
    staticClass: "b-title pl-20 fs-16 bold mb-20"
  }, [_vm._v(_vm._s(_vm.$t("pagebottom.organizers")))]), _vm._v(" "), _vm._l((_vm.list2), function(v, i) {
    return _c('a', {
      key: i,
      staticClass: "pl-20 fs-14 mb-20 link",
      attrs: {
        "href": v.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(v.name) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "block mb-40"
  }, [_c('div', {
    staticClass: "b-title pl-20 fs-16 bold mb-20"
  }, [_vm._v(_vm._s(_vm.$t("pagebottom.executive")))]), _vm._v(" "), _c('a', {
    staticClass: "pl-20 fs-14 mb-20 link",
    attrs: {
      "href": "https://expounion.com.cn/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("pagebottom.executive1")) + "\n          ")])])])], 1), _vm._v(" "), _c('footer', {
    staticClass: "fs-14 pt-30 pb-30"
  }, [_c('div', {
    staticClass: "nav mb-bottom"
  }, _vm._l((_vm.nav), function(v, i) {
    return _c('a', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.toFriend(v.url)
        }
      }
    }, [_c('div', {
      staticClass: "flex-container nav_item"
    }, [_c('span', [_vm._v(_vm._s(v.name))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "copyright  clearfix"
  }, [_c('div', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("pagebottom.copyright")) + "\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 粤ICP备17092841号-4")])])])], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb99494e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageFooter.vue
// module id = null
// module chunks = 